import {
	LOGOUT,
	O365_REGISTER_SUCCESS,
	BSRS_LOGIN_SUCCESS,

	CORE_FORGOT_PASSWORD_REQUEST,
	CORE_FORGOT_PASSWORD_SUCCESS,

	CORE_CONFIRM_RESET_PASSWORD_REQUEST,
	CORE_CONFIRM_RESET_PASSWORD_SUCCESS,

} from '../../types'

import { getAllToken, getUserInfo, getBSRSToken } from 'Lib'

const allToken = getAllToken()
const bsrsToken = getBSRSToken()

const initialState = {
	token: allToken,
	bsrsToken,
	user: getUserInfo(allToken.access_token)
}

export default {
	authen: (state = initialState, action) => {
		switch (action.type) {
			case O365_REGISTER_SUCCESS: {
				return {
					...state,
					token: {
						...action.payload.token
					},
					user: getUserInfo(action.payload.token.access_token)
				}
			}
			case BSRS_LOGIN_SUCCESS: {
				return {
					...state,
					bsrsToken: action.payload.bsrsToken,
					user: action.payload
				}
			}
			case LOGOUT:
				return {
					...state,
					bsrsToken: undefined
				}
			default:
				return state
		}
	},
	forgotPassword: (state = {}, action) => {
		switch (action.type) {
			case CORE_FORGOT_PASSWORD_REQUEST:
				return {}
			case CORE_FORGOT_PASSWORD_SUCCESS:
				return action.payload
			default:
				return state
		}
	},
	resetPassword: (state = {}, action) => {
		switch (action.type) {
			case CORE_CONFIRM_RESET_PASSWORD_REQUEST:
				return {}
			case CORE_CONFIRM_RESET_PASSWORD_SUCCESS:
				return action.payload
			default:
				return state
		}
	},
}


// WEBPACK FOOTER //
// ./src/features/auth/reducer.js